export default function formatAmountString(amountString) {
    if (!amountString) {
        return '--';
    }

    return amountString.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
